// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"6c70bb13","239":"e12555e1","728":"2070073a","732":"26938f8d","786":"4574e753","803":"f01bd266"}[chunkId] + ".css";
};